import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "innerProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { components } from '@atlaskit/select';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl-next';
import { messages } from './i18n';
import { isChildInput } from './utils';
import ValueContainerWrapper from './ValueContainerWrapper';
export var MultiValueContainer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MultiValueContainer, _React$PureComponent);
  var _super = _createSuper(MultiValueContainer);
  function MultiValueContainer(props) {
    var _this;
    _classCallCheck(this, MultiValueContainer);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "timeoutId", null);
    _defineProperty(_assertThisInitialized(_this), "scrollToBottom", function () {
      _this.timeoutId = window.setTimeout(function () {
        var current = _this.valueContainerInnerProps.ref.current;
        if (current !== null) {
          var container = ReactDOM.findDOMNode(current);
          if (container instanceof HTMLDivElement) {
            container.scrollTop = container.scrollHeight;
          }
        }
        _this.timeoutId = null;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "showPlaceholder", function () {
      var value = _this.props.selectProps.value;
      return value && value.length > 0;
    });
    _defineProperty(_assertThisInitialized(_this), "addPlaceholder", function (placeholder) {
      var children = React.Children.map(_this.props.children, function (child) {
        return isChildInput(child) && _this.showPlaceholder() ? /*#__PURE__*/React.cloneElement(child, {
          placeholder: placeholder
        }) : child;
      });
      return /*#__PURE__*/React.createElement(Fragment, null, children);
    });
    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      var _this$props$selectPro = _this.props.selectProps,
        addMoreMessage = _this$props$selectPro.addMoreMessage,
        isDisabled = _this$props$selectPro.isDisabled;
      // Do not render "Add more..." message if picker is disabled
      if (isDisabled) {
        return _this.props.children;
      }
      if (addMoreMessage === undefined) {
        return /*#__PURE__*/React.createElement(FormattedMessage, messages.addMore, function (addMore) {
          var _join, _addMoreMessages;
          var addMoreMessages = addMore;
          if (addMore && typeof addMore === 'string') {
            addMoreMessages = [addMore];
          }
          var placeholder = (_join = (_addMoreMessages = addMoreMessages) === null || _addMoreMessages === void 0 ? void 0 : _addMoreMessages.join('')) !== null && _join !== void 0 ? _join : '';
          return _this.addPlaceholder(placeholder);
        });
      }
      return _this.addPlaceholder(addMoreMessage);
    });
    //@ts-ignore react-select unsupported props
    _defineProperty(_assertThisInitialized(_this), "onValueContainerClick", _this.props.selectProps.onValueContainerClick);
    _this.state = {
      valueSize: 0,
      previousValueSize: 0
    };
    _this.valueContainerInnerProps = {
      ref: /*#__PURE__*/React.createRef()
    };
    return _this;
  }
  _createClass(MultiValueContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state = this.state,
        previousValueSize = _this$state.previousValueSize,
        valueSize = _this$state.valueSize;
      //@ts-ignore react-select unsupported props
      var isFocused = this.props.selectProps.isFocused;
      if (valueSize > previousValueSize && isFocused) {
        if (this.timeoutId) {
          window.clearTimeout(this.timeoutId);
          this.timeoutId = null;
        }
        this.scrollToBottom();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        innerProps = _this$props.innerProps,
        valueContainerProps = _objectWithoutProperties(_this$props, _excluded);
      var props = _objectSpread(_objectSpread({}, valueContainerProps), {}, {
        innerProps: this.valueContainerInnerProps
      });
      return /*#__PURE__*/React.createElement(ValueContainerWrapper, {
        isEnabled: this.onValueContainerClick,
        onMouseDown: this.onValueContainerClick
      }, /*#__PURE__*/React.createElement(components.ValueContainer, props, this.renderChildren()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      return {
        valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
        previousValueSize: prevState.valueSize
      };
    }
  }]);
  return MultiValueContainer;
}(React.PureComponent);